<template>
    <el-menu
      text-color="#3d3533"
      active-text-color="#ffffff"
      :default-active="defaultActive"
      class="menu-tree"
      @select="handleSelect">
      <el-menu-item index="1">
        <span slot="title">
          <div class="row-num">
            待处理
            <div class="num_count">{{ headInfo.todoCount }}</div>
          </div>
        </span>
      </el-menu-item>
      <el-menu-item index="5">
        <span slot="title">
          <div class="row-num row-child">
            协同办公
          </div>
        </span>
      </el-menu-item>
      <el-menu-item index="6">
        <span slot="title">
          <div class="row-num row-child">
            销售管理
          </div>
        </span>
      </el-menu-item>
      <el-menu-item index="2">
        <span slot="title">
          <div class="row-num">
            已处理
            <div class="num_count">{{ headInfo.doneCount }}</div>
          </div>
        </span>
      </el-menu-item>
      <el-menu-item index="7">
        <span slot="title">
          <div class="row-num row-child">
            协同办公
          </div>
        </span>
      </el-menu-item>
      <el-menu-item index="8">
        <span slot="title">
          <div class="row-num row-child">
            销售管理
          </div>
        </span>
      </el-menu-item>
      <el-menu-item index="3">
        <span slot="title">
          <div class="row-num">
            待阅<div class="num_count">{{ headInfo.toReadCount }}</div>
          </div>
        </span>
      </el-menu-item>
      <el-menu-item index="4">
        <span slot="title">
          <div class="row-num">
            已阅<div class="num_count">{{ headInfo.readCount }}</div>
          </div>
        </span>
      </el-menu-item>
    </el-menu>
</template>

<script>
export default {
  data(){
    return {
      headInfo:{},
      defaultActive: '1'
    }
  },
  mounted() {
    this.initDefaultActive()
    this.getHeadInfo()
    // 初始化时设置高度
    this.setMenuHeight();
    // 监听窗口大小变化
    window.addEventListener('resize', this.setMenuHeight);
  },
  beforeDestroy() {
    // 组件销毁前移除监听
    window.removeEventListener('resize', this.setMenuHeight);
  },
  methods: {
    initDefaultActive() {
      const route = this.$route || {}
      const routeDefaultActive =
        (route.query && route.query.defaultActive) ||
        (route.params && route.params.defaultActive)

      this.defaultActive = routeDefaultActive ? String(routeDefaultActive) : '1'
    },
    setMenuHeight() {
      const menu = document.querySelector('.menu-tree');
      if (menu) {
        menu.style.height = `${window.innerHeight - 70}px`;
      }
    },
    handleSelect(index){
      if(index === 0){
        return ;
      }
      this.$emit('handleSelect',index)
    },
    getHeadInfo() {
      this.$axios.post(this.global.BASE_URL_2971 + '/msi/flow/engine/task/findTaskCount', { data: {} })
        .then(res => {
          if (res.data.code === '0000') {
            console.log(res.data.data)
            this.headInfo = res.data.data
          }
        })
    },
  }
}
</script>

<style scoped>
.menu-tree {
  height: calc(100vh - 30px) !important; /* 初始高度设置为视口高度 */
  overflow-y: hidden; /* 内容超出时显示滚动条 */
  background-color: transparent; /* 可选：设置背景色 */
  padding-top: 12px;
  font-size: 14px;
  margin-left: 4px;
}

/* 可选：美化滚动条样式 */
.menu-tree::-webkit-scrollbar {
  width: 6px;
}

.menu-tree::-webkit-scrollbar-thumb {
  background-color: #dcdfe6;
  border-radius: 3px;
}

.menu-tree::-webkit-scrollbar-track {
  background-color: #f5f7fa;
}

.el-menu-item.is-active {
  background-color:#bb0009 !important;
}
.el-menu-item {
  height: auto;
  line-height:40px;
  border-radius: 5px !important;
  margin-bottom: 8px;
  font-size: -apple-system,BlinkMacSystemFont,"Segoe UI","PingFang SC","Hiragino Sans GB",STHeitiSC,Helvetica,"Helvetica Neue","Microsoft YaHei",Tahoma;
}
.el-menu-item:hover {
  background-color: rgba(255,157,138,0.2) !important;
}
.row-num {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.row-child {
  margin-left: 10px;
}
.num_count {
  height: 18px;
  min-width: 8px;
  /* max-width: 22px; */
  padding: 0 5px;
  font: 12px/18px arial;
  background:#bb0009;
  display: inline-block;
  overflow: hidden;
  color: #fff;
  text-align: center;
  border-radius: 18px;
  margin-left: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/views/flow-center/components/menuTree.vue